export default {"src":"/_next/static/media/0x40af3827f39d0eacbf4a168f8d4ee67c121d11c9.c044dbfa.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};